module.exports = __webpack_public_path__ + "media/images/pc/costumes/mv_kimono-dcc59849652a65e231fc080ab2947190.jpg";